// extracted by mini-css-extract-plugin
export default {"wrapper":"TKxUxS","sub-header":"byhmaV","subHeader":"byhmaV","min-price":"Hou88L","minPrice":"Hou88L"};